<template>
  <div class="view-floating-nav">
    <cms-floating-nav
      v-if="floatingNavSetUp"
      :theme="floatingNavOptions"
      :floating-nav="homepage.floating_nav"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import isEmpty from 'lodash/isEmpty';

const store = useStore();

const theme = computed(() => store.state.theme);
const homepage = computed(() => store.state.homepage);

const floatingNavOptions = computed(() => ({
  ...theme.value.floating_nav.options,
  translations: store.getters['translation/getComponentTranslation']('floating_nav'),
  globalThemeSettings: store.getters.getGlobalThemeSettings,
}));

const floatingNavSetUp = computed(() => homepage.value.floating_nav && !isEmpty(homepage.value.floating_nav.buttons));
</script>
